import { render } from "./DatingData.vue?vue&type=template&id=59c6b918&scoped=true"
import script from "./DatingData.vue?vue&type=script&lang=js"
export * from "./DatingData.vue?vue&type=script&lang=js"

import "./DatingData.vue?vue&type=style&index=0&id=59c6b918&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c6b918"]])

export default __exports__